import axios from 'axios';
import { jwtDecode } from "jwt-decode";
import { updateReleaseById } from '../controllers/releaseController';

const API_URL = 'https://dittmagasin.no/api/v2';

const BEARER_TOKEN = 'kj5VjcbrNnrYEDxlRgdaEfsP2vm1lnc46F0PKVdwZ7yBdXr77eifamRMI6Lf';

const releaseService = {
    fetchReleases: async (params, magazineId) => {
        try {
            const token = localStorage.getItem('token');
            const user = localStorage.getItem('user');
            const response = await axios.post(`${API_URL}/releases`,
                { magazine_id: magazineId, q: params.q, sort_by: params.sortBy, sort_order: params.sortOrder, page: params.page, offset: params.offset},
                {
                    params: { per_page: params.perPage,},
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data;
        } catch (error) {
            console.error('Failed to fetch releases:', error);
            return null;
        }
    },
    fetchAllReleases: async (magazineId = 11) => {
        try {
            const token = localStorage.getItem('token');
            const user = localStorage.getItem('user');
            const response = await axios.post(`${API_URL}/get-releases`,
                { magazine_id: magazineId },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch releases:', error);
            return null;
        }
    },
    fetchReleaseByID: async (params) => {
        try {
            const token = localStorage.getItem('token');
            const user = localStorage.getItem('user');
            const response = await axios.post(`${API_URL}/get-release`,
                {
                    magazine_id: params.magazineId,
                    release_id: params.releaseId
                },
                {
                    headers: {
                        Authorization: `Bearer ${token}`,
                        'Content-Type': 'application/json'
                    }
                }
            );
            return response.data?.data || [];
        } catch (error) {
            console.error('Failed to fetch releases:', error);
            return null;
        }
    },
    updateReleaseById: async (params,updatedData) => {
        try {
            var postData = {
                'magazine_id': params.magazineId,
                'release_id': params.releaseId,
                'introduction': updatedData['introduction'],
                'cover_file': updatedData['cover_file'],
                'display_name': updatedData['display_name'],
                'issued_date': updatedData['issued_date'],
                'publish_date': updatedData['publish_date'],
                'is_free': updatedData['is_free'],
                'ga_code': updatedData['ga_code'],
            }
            const res = await fetch(`${API_URL}/edit-release`, {
                method: "POST",
                headers: { "Content-Type": "application/json", params },
                body: JSON.stringify(postData),
            });
            // const res = {};
            return await res.json();
        } catch (error) {
            console.error("Error updating release:", error);
        }
    },
};


export default releaseService;
